<template>
  <div
    @click="onBodyClicked"
    class="home"
  >
    <welcome
      :title="title"
      :showBrugerInfo="true"
      :editingUser="editingUser"
      :setEditingUser="setEditingUser"
    />
    <ruter
      :editingTitle="editingTitle"
      :setEditingTitle="setEditingTitle"
    />
  </div>
</template>

<script>
import Welcome from '@/components/Home/Welcome.vue';
import Ruter from '@/components/Home/Ruter.vue';

export default {
  name: 'home',
  components: {
    Welcome,
    Ruter,
  },
  data: function() {
    return {
      editingTitle: undefined,
      editingUser: undefined,
      title: process.env.VUE_APP_TITLE,
    };
  },
  methods: {
    setEditingTitle(id) {
      this.editingTitle = id;
    },
    setEditingUser(property) {
      this.editingUser = property;
    },
    onBodyClicked() {
      this.setEditingTitle(undefined);
      this.setEditingUser(undefined);
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  flex: 1;
  overflow: hidden;
  position: relative;
}
</style>
